import type { TvShowEpisodeUrlParams } from '~/entities/redirect-url/index.h'
import type { TvShowEpisodePayment } from '../../interfaces'

import { createEvent, sample } from 'effector'
import { createAction } from 'effector-action'
import { model as redirectUrlModel } from '~/entities/redirect-url'
import { aye } from '~/shared/helpers'
import { getPriceSettingsExternalPaymentData } from '~/shared/price-settings/helpers'
import {
  getPaymentTvShowEpisodeMediaType,
  getPaymentTvShowEpisodePriceSettings,
  isPaid,
} from '../../lib'
import * as external from '../model'

export const selectTvShowEpisode = createEvent<TvShowEpisodePayment>()

export const navigateToPlayer = createEvent()
export const saveRedirectUrl = createEvent<TvShowEpisodeUrlParams>()

export const processTvShowEpisodePayment = createEvent<TvShowEpisodePayment>()
export const processByExternal = createEvent<TvShowEpisodePayment>()

sample({
  clock: selectTvShowEpisode,
  fn: ({
    id,
    seasonId,
    tvShowId,
    queryCategoryId,
    queryCollectionId,
    queryShowIndex,
  }) => ({
    id,
    seasonId,
    tvShowId,
    queryCategoryId,
    queryCollectionId,
    queryShowIndex,
  }),
  target: redirectUrlModel.saveTvShowEpisodeRedirectUrl,
})

createAction({
  clock: selectTvShowEpisode,
  target: {
    processTvShowEpisodePayment,
    navigateToPlayer,
  },
  fn: (target, episode) => {
    if (isPaid(episode)) {
      return target.processTvShowEpisodePayment(episode)
    }

    return target.navigateToPlayer()
  },
})

sample({
  clock: navigateToPlayer,
  target: redirectUrlModel.redirectToShowPlayer,
})

sample({
  clock: processTvShowEpisodePayment,
  source: external.$externalPaymentEnabled,
  filter: (externalPaymentEnabled) => aye(externalPaymentEnabled),
  fn: (_, episode) => episode,
  target: processByExternal,
})

sample({
  clock: processByExternal,
  fn: (episode) => {
    const { id, seasonId, tvShowId, externalId } = episode
    const priceSettings = getPaymentTvShowEpisodePriceSettings(episode)

    return {
      id,
      seasonId,
      tvShowId,
      mediaType: getPaymentTvShowEpisodeMediaType(episode),
      ...getPriceSettingsExternalPaymentData(priceSettings, externalId),
    }
  },
  target: external.selectForExternalPayment,
})
